// extracted by mini-css-extract-plugin
export var Digital = "benefits-module--Digital--bbae4";
export var Fuel = "benefits-module--Fuel--a06dc";
export var Money = "benefits-module--Money--cb9d9";
export var Time = "benefits-module--Time--d716c";
export var Trees = "benefits-module--Trees--46847";
export var amount = "benefits-module--amount--a8d0c";
export var amountLabel = "benefits-module--amountLabel--e1105";
export var benefit = "benefits-module--benefit--68d8d";
export var benefitWrapper = "benefits-module--benefitWrapper--25ee8";
export var icon = "benefits-module--icon--41847";
export var iconDigital = "benefits-module--iconDigital--6f1b9";
export var iconFuel = "benefits-module--iconFuel--bee52";
export var iconMoney = "benefits-module--iconMoney--567c8";
export var iconTime = "benefits-module--iconTime--1fba5";
export var iconTrees = "benefits-module--iconTrees--933a5";
export var learnmore = "benefits-module--learnmore--a7143";
export var more = "benefits-module--more--6f030";
export var name = "benefits-module--name--ee228";